/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Facts_TitleInputs */

const en_about_facts_title = /** @type {(inputs: About_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Facts`)
};

const de_about_facts_title = /** @type {(inputs: About_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eckdaten`)
};

const fr_about_facts_title = /** @type {(inputs: About_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En bref`)
};

const es_about_facts_title = /** @type {(inputs: About_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos clave`)
};

const it_about_facts_title = /** @type {(inputs: About_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati chiave`)
};

const nl_about_facts_title = /** @type {(inputs: About_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belangrijke feiten`)
};

const pl_about_facts_title = /** @type {(inputs: About_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kluczowe fakty`)
};

const fi_about_facts_title = /** @type {(inputs: About_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaintiedot`)
};

const da_about_facts_title = /** @type {(inputs: About_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noglefakta`)
};

const sv_about_facts_title = /** @type {(inputs: About_Facts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyckelfakta`)
};

/**
* | output |
* | --- |
* | "Key Facts" |
*
* @param {About_Facts_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_facts_title = /** @type {((inputs?: About_Facts_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Facts_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_facts_title(inputs)
	if (locale === "fr") return fr_about_facts_title(inputs)
	if (locale === "es") return es_about_facts_title(inputs)
	if (locale === "it") return it_about_facts_title(inputs)
	if (locale === "nl") return nl_about_facts_title(inputs)
	if (locale === "pl") return pl_about_facts_title(inputs)
	if (locale === "fi") return fi_about_facts_title(inputs)
	if (locale === "da") return da_about_facts_title(inputs)
	if (locale === "sv") return sv_about_facts_title(inputs)
	return en_about_facts_title(inputs)
});